import Vue from 'vue'
import Component from 'vue-class-component'


@Component({
  props: {
    value: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    min: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 1
    }
  },
  model: {
    prop: 'value',
    event: 'changeValue'
  },
  watch: {
    value: {
      handler(val) {
        this.sliderValue = val
      },
      immediate: true
    }
  },
})
export default class StyleSlider extends Vue { 
  sliderValue = 0
  inputChange(val) {
    this.$emit('changeValue', val)
    this.$emit('input', val)
  }
  changeSliderVal(val) {
    this.$emit('changeValue', val)
    this.$emit('change', val)
  }
}